import {
	Popover,
	PopoverSurface,
	PopoverTrigger,
	mergeClasses,
} from "@fluentui/react-components";
import { PopoverTriggerProps, PopoverViewProps } from "./types";
import { useStyle } from "./style";

export const PopoverView = (props: PopoverViewProps) => {
	const classes = useStyle();

	const triggerComponent = () => {
		let content: JSX.Element | undefined;
		let title: string | undefined;

		if ((props.trigger as JSX.Element).type) {
			content = props.trigger as JSX.Element;
		} else {
			const trigger = props.trigger as PopoverTriggerProps;
			content = trigger.content;
			title =
				!trigger.titleVisibility ||
				trigger.titleVisibility == "always" ||
				(trigger.titleVisibility == "onDisabled" && props.disabled) ||
				(trigger.titleVisibility == "onEnabled" && !props.disabled)
					? trigger.title
					: undefined;
		}

		return (
			<button
				disabled={props.disabled}
				title={title}
				className={mergeClasses(classes.trigger, props.classes?.trigger)}
			>
				{content}
			</button>
		);
	};

	return (
		<Popover
			inline={!props.renderOutsideTheDOM}
			aria-modal="false"
			withArrow={props.withArrow}
			trapFocus={props.trapFocus}
			unstable_disableAutoFocus={props.disableAutoFocus}
			appearance={props.appearance}
			closeOnScroll={props.closeOnScroll}
			defaultOpen={props.defaultOpen}
			mouseLeaveDelay={props.mouseLeaveDelay}
			openOnContext={props.openOnContext}
			openOnHover={props.openOnHover}
			closeOnIframeFocus={props.closeOnIframeFocus}
			positioning={props.positioning}
			size={props.size}
			inertTrapFocus={props.inertTrapFocus}
			open={props.open}
			onOpenChange={props.onOpenChange}
			mountNode={props.mountNode?.current || undefined}
		>
			<PopoverTrigger disableButtonEnhancement>
				{triggerComponent()}
			</PopoverTrigger>
			<PopoverSurface
				className={mergeClasses(classes.container, props.classes?.content)}
				style={props.contentStyle}
			>
				{props.content}
			</PopoverSurface>
		</Popover>
	);
};
